import { memo, useEffect } from 'react';
import Image from 'next/image';
import styles from './IntroductionPage.module.scss';
import { IntroductionPageProps } from './IntroductionPage.types';
import LinkButton from '@/components/LinkButton';
import { useRouter } from 'next/router';
import * as cheerio from 'cheerio';
import { handleRichText } from '@/utils/handleRichText';
import { useLanguage } from '@/hooks/use-language';

export default memo((props: IntroductionPageProps) => {
  const {
    title,
    wiki_category_setup: { description, category_sections },
    table_of_content_reference
  } = props?.data;

  const router = useRouter();
  const language = useLanguage();

  const getTargetArticle = (index: number) => {
    const collapseList = table_of_content_reference[0]?.table_of_content_entry || [];
    const targetCategory = collapseList[index];
    const targetArticle = targetCategory?.blog_post[0]?.blog[0];
    return targetArticle;
  };

  const extractPlainText = (html: any) => {
    const $ = cheerio.load(html);

    $('h2').each((index, element) => {
      const $h2 = $(element);
      const id = $h2.text();
      $h2.attr('id', id.replace(/\s/g, ''));
    });

    const updatedHtml = $.html();

    return updatedHtml;
  };

  const handleImgInLink = (ElementStr: string) => {
    const $ = cheerio.load(ElementStr);

    $('a').each((index, element) => {
      const img = $(element).find('img');
      if (img.length > 0) {
        $(element).addClass('imgIn');
      }
    });

    const res = $.html();
    let modifiedStr = extractPlainText(res);

    return modifiedStr;
  };

  // 埋点
  const handleLearnMore = (index: number) => {
    const targetArticle = getTargetArticle(index);
    window?.dataLayer?.push({
      event: 'buttonClick',
      buttonTitle: 'content_nav_article',
      description: targetArticle.title,
      pageURL: window.location.href,
      componentName: 'content nav'
    });
  };

  // 埋点
  useEffect(() => {
    category_sections.forEach(section => {
      if (section.chapter_description) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(section.chapter_description, 'text/html');
        const aDom = doc.querySelectorAll('a');
        for (let i = 0; i < aDom.length; i++) {
          aDom[i].addEventListener('click', function () {
            window?.dataLayer?.push({
              event: 'buttonClick',
              buttonTitle: 'article_hyperlink',
              description: aDom[i].text,
              destinationUrl: aDom[i].href,
              pageURL: window.location.href,
              componentName: 'article hyperlink'
            });
          });
        }
      }
    });
  }, []);

  return (
    <div className={styles.intro_wrapper}>
      <h1 className={styles.page_title}>{title}</h1>
      <div className={styles.intro_description}>{description}</div>
      {category_sections.map((item: any, index: number) => {
        return (
          <div className={styles.item_block} key={item.title}>
            <div className={styles.item_index}>{index + 1}</div>
            <div className={styles.right_contain}>
              <div className={styles.item_contain}>
                <h2 className={styles.item_title}>{item.chapter_title}</h2>
                <div
                  className={styles.item_description}
                  id={'rich_text_wrapper'}
                  key={index}
                  dangerouslySetInnerHTML={{
                    __html: handleRichText(handleImgInLink(item.chapter_description))
                  }}
                ></div>
                <div onClick={() => handleLearnMore(index)}>
                  <LinkButton
                    title={'了解更多'}
                    targetUrl={`/${language}/blog/guide${getTargetArticle(index)?.url}`}
                  ></LinkButton>
                </div>
              </div>
              <Image
                className={styles.item_img}
                src={item.chapter_image?.url}
                alt={''}
                width={15}
                height={15}
              ></Image>
            </div>
          </div>
        );
      })}
    </div>
  );
});
